import { useEffect } from 'react'
import Router from 'next/router'
import { stopSessionReplayOnSecretUrl, syncSessionReplayWithUrl } from 'lib/tracking/datadog'

const handleRouteChangeSettled = () => syncSessionReplayWithUrl(window.location.href)

/**
 * `routeChangeStart` fires before Next pushes history, so replay stops before a token URL is recorded.
 * It only starts again once the navigation settles, when `location.href` is the new URL.
 */
export const useSessionReplayGuard = () => {
  useEffect(() => {
    Router.events.on('routeChangeStart', stopSessionReplayOnSecretUrl)
    Router.events.on('routeChangeComplete', handleRouteChangeSettled)
    Router.events.on('routeChangeError', handleRouteChangeSettled)

    return () => {
      Router.events.off('routeChangeStart', stopSessionReplayOnSecretUrl)
      Router.events.off('routeChangeComplete', handleRouteChangeSettled)
      Router.events.off('routeChangeError', handleRouteChangeSettled)
    }
  }, [])
}
